<template>
  <div class="dateandtime" :class="darkMode ? 'dark' : ''">
    <div class="label f8">{{ $t('Select A Date') }}</div>
    <div class="mobiledate date">
      <MobileDate
        :startTime="startTime"
        :location="location"
        :currentTime="currentTime"
        v-on="$listeners" />
    </div>
    <div class="desktopdate date">
      <DesktopDate
        :startTime="startTime"
        :currentTime="currentTime"
        v-on="$listeners" />
    </div>
    <StartTime class="starttime mobile"
      :otherTimesNumber="6"
      :booking="booking"
      :bookings="bookings"
      :location="location"
      :currentTime="currentTime"
      :startTime="startTime"
      v-on="$listeners" />
    <StartTime class="starttime desktop"
      :otherTimesNumber="10"
      :booking="booking"
      :bookings="bookings"
      :location="location"
      :currentTime="currentTime"
      :startTime="startTime"
      v-on="$listeners" />
  </div>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';

import DesktopDate from './DesktopDate';
import MobileDate from './MobileDate';
import StartTime from '@/location/booking/components/StartTime';

@Component({
  props: {
    booking: {
      type: Object,
      required: true,
    },
    location: {
      type: Object,
      required: true,
    },
    currentTime: {
      type: String,
      required: true,
    },
    bookings: {
      type: Array,
      required: true,
    },
    startTime: {
      type: String,
      required: true,
    },
    darkMode: {
      type: Boolean,
      required: false,
    },
  },
  components: {
    DesktopDate,
    MobileDate,
    StartTime,
  },
})
export default class DateAndTime extends Vue {
}
</script>

<style scoped lang="postcss">
@import 'core/shared/styles';

.label {
  margin-bottom: var(--spacingXS);
}

.date {
  margin-bottom: var(--spacingLg);
}

.mobiledate {
  @media (--desktop) {
    display: none;
  }
}

.desktopdate {
  display: none;

  @media (--desktop) {
    display: block;
  }
}

.desktop {
  display: none;
}

@media (--tablet) {
  .desktop {
    display: block;
  }
  .mobile {
    display: none;
  }
}

.dateandtime.dark .label {
  color: var(--darkModeColorText);
}

.dateandtime.dark .desktop /deep/ .top .startnoworcustom .label {
  color: var(--darkModeColorText);
}

.dateandtime.dark .desktop /deep/ .top .other-times .label {
  color: var(--darkModeColorText);
}

.dateandtime.dark .desktop /deep/ .top .startnoworcustom .ui-button {
  background-color: var(--darkModeColorBackground);
  color: var(--darkModeColorText);
}

.dateandtime.dark .desktop /deep/ .top .other-times .ui-button{
  background-color: var(--darkModeColorBackground);
  color: var(--darkModeColorText);
}

.dateandtime.dark .desktop /deep/ .customstart span{
  color: var(--darkModeColorText);
}

.dateandtime.dark .desktop /deep/ .customstart .ui-timepicker {
  background-color: var(--darkModeColorBackground);
  color: var(--darkModeColorText);
}

.dateandtime.dark .desktopdate .desktop-date-with-arrows /deep/ .date-grid :hover {
  background-color: var(--darkModeColorLightBackground);
}

.dateandtime.dark .desktopdate .desktop-date-with-arrows /deep/ .date-grid .date{
  & .dow {
    color: var(--darkModeColorText);
  }
  & .month {
    color: var(--darkModeColorText);
  }
}
</style>
